

import { GetNetworksServiceResponse } from 'types/networksService';
import { networksStore } from '../store/networksStore';
import { $client } from './client';

export class NetworksService {
  async getNetworks() {
    try {
      const response = await $client.get<GetNetworksServiceResponse>(
        'api/networks'
      );

      networksStore.setState({ networks: response.data });
    } catch (error) {
      console.error(error);

      throw new Error('Something went wrong while getting networks');
    }
  }
}

export const networksService = new NetworksService();
